import { render, staticRenderFns } from "./BrandIGraphsSection.vue?vue&type=template&id=ca5f0e4e"
import script from "./BrandIGraphsSection.vue?vue&type=script&lang=ts"
export * from "./BrandIGraphsSection.vue?vue&type=script&lang=ts"
import style0 from "./BrandIGraphsSection.vue?vue&type=style&index=0&id=ca5f0e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports